import type { IconProps } from "./icon-types";

/**
 * 연필(edit). Modal 헤더 액션 등에서 사용.
 *
 * 글리프는 `react-icons/lu`의 `LuPencil`(Lucide `pencil`)을 인라인으로 재현 —
 * c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 * 다른 c6 아이콘(Trash/PanelLeft 등)과 톤·크기를 맞추기 위해 24 그리드 / stroke 기반 사용.
 */
export const EditIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
    <path d="m15 5 4 4" />
  </svg>
);
